import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoAlarmasDomiciliariasComponent } from './alarmas-domiciliarias/listado-alarmas-domiciliarias/listado-alarmas-domiciliarias.component';
import { MapaAlarmasComponent } from './mapa-alarmas/mapa-alarmas.component';
import { CrearEditarCodigosDispositivosComponent } from '../../standalone/codigos-dispositivos/crear-editar-codigos-dispositivos/crear-editar-codigos-dispositivos.component';
import { ListadoCodigosDispositivoComponent } from '../../standalone/codigos-dispositivos/listado-codigos-dispositivos/listado-codigos-dispositivos.component';
import { ListadoModelosDispositivosComponent } from '../../standalone/modelos-dispositivos/listado-modelos-dispositivos/listado-modelos-dispositivos.component';
import { CrearEditarModeloDispositivoComponent } from '../../standalone/modelos-dispositivos/crear-editar-modelo-dispositivo/crear-editar-modelo-dispositivo.component';
import { CrearAlarmaDomiciliariaCompletoComponent } from './alarmas-domiciliarias/crear-alarma-domiciliaria-completo/crear-alarma-domiciliaria-completo.component';
import { DetallesAlarmaComponent } from './alarmas-domiciliarias/detalles-alarma/detalles-alarma.component';
import { ListadoUbicacionesComponent } from '../../standalone/ubicaciones/listado-ubicaciones/listado-ubicaciones.component';
import { CrearEditarUbicacionComponent } from '../../standalone/ubicaciones/crear-editar-ubicacion/crear-editar-ubicacion.component';

const routes: Routes = [
  { path: '', redirectTo: 'mapa', pathMatch: 'full' },
  //Mapa
  {
    path: 'mapa',
    title: 'Mapa de alarmas',
    component: MapaAlarmasComponent,
    canActivate: [],
  },
  // AlarmasDomiciliarias
  {
    path: 'alarmasDomiciliarias',
    title: 'Alarmas domiciliarias',
    component: ListadoAlarmasDomiciliariasComponent,
    canActivate: [],
  },
  {
    path: 'alarmasDomiciliarias/crear',
    title: 'Nueva alarma',
    component: CrearAlarmaDomiciliariaCompletoComponent,
    canActivate: [],
  },
  {
    path: 'alarmasDomiciliarias/editar/:id',
    title: 'Editar alarma',
    component: CrearAlarmaDomiciliariaCompletoComponent,
    canActivate: [],
  },
  {
    path: 'alarmasDomiciliarias/editar/:id/:tab',
    title: 'Editar alarma',
    component: CrearAlarmaDomiciliariaCompletoComponent,
    canActivate: [],
  },
  {
    path: 'alarmasDomiciliarias/detallesAlarma/:id',
    title: 'Alarma',
    component: DetallesAlarmaComponent,
    canActivate: [],
  },
  // Zonas geográficas de alarmas (IUbicacion categoria 'Alarmas'). Componentes
  // genéricos parametrizados por :categoria, igual que las zonas de luminarias.
  {
    path: 'zonas/:categoria',
    title: 'Zonas',
    component: ListadoUbicacionesComponent,
    canActivate: [],
  },
  {
    path: 'zonas/:categoria/crear',
    title: 'Nueva zona',
    component: CrearEditarUbicacionComponent,
    canActivate: [],
  },
  {
    path: 'zonas/:categoria/editar/:id',
    title: 'Editar zona',
    component: CrearEditarUbicacionComponent,
    canActivate: [],
  },

  // Codigos Dispositivos
  {
    path: 'codigosDispositivos/:tipo',
    title: 'Códigos de dispositivos',
    component: ListadoCodigosDispositivoComponent,
    canActivate: [],
  },
  {
    path: 'codigosDispositivos/:tipo/crear',
    title: 'Nuevo código',
    component: CrearEditarCodigosDispositivosComponent,
    canActivate: [],
  },
  {
    path: 'codigosDispositivos/:tipo/editar/:id',
    title: 'Editar código',
    component: CrearEditarCodigosDispositivosComponent,
    canActivate: [],
  },

  // Modelos Dispositivos
  {
    path: 'modelosDispositivos/:tipo',
    title: 'Modelos de dispositivos',
    component: ListadoModelosDispositivosComponent,
    canActivate: [],
  },
  {
    path: 'modelosDispositivos/:tipo/crear',
    title: 'Nuevo modelo',
    component: CrearEditarModeloDispositivoComponent,
    canActivate: [],
  },
  {
    path: 'modelosDispositivos/:tipo/editar/:id',
    title: 'Editar modelo',
    component: CrearEditarModeloDispositivoComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AlarmasRoutingModule {}
